var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporateConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    viewBox: "0 0 27 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8359 1.16569V5.91569L0.835938 5.91569V1.16569C0.835938 0.955727 0.919344 0.754363 1.06781 0.605897C1.21628 0.45743 1.41764 0.374023 1.6276 0.374023L19.0443 0.374023C19.2542 0.374023 19.4556 0.45743 19.6041 0.605897C19.7525 0.754363 19.8359 0.955727 19.8359 1.16569Z",
    fill: "#1880AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8359 7.49902V12.249C19.8359 12.459 19.7525 12.6604 19.6041 12.8088C19.4556 12.9573 19.2542 13.0407 19.0443 13.0407H1.6276C1.41764 13.0407 1.21628 12.9573 1.06781 12.8088C0.919344 12.6604 0.835938 12.459 0.835938 12.249V7.49902L19.8359 7.49902Z",
    fill: "#1880AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9336 0.37207H26.2193C26.4087 0.37207 26.5904 0.429138 26.7244 0.53072C26.8583 0.632303 26.9336 0.770078 26.9336 0.913737V12.8304C26.9336 12.9741 26.8583 13.1118 26.7244 13.2134C26.5904 13.315 26.4087 13.3721 26.2193 13.3721H21.9336V0.37207Z",
    fill: "#1880AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateConnect);
export default __webpack_public_path__ + "static/media/corporateConnect.b519c2917761d766d650b9f262a1bd76.svg";
export { ForwardRef as ReactComponent };